export interface IClient {
    createUser?: string;
    updateUser?: string;   
    createTime?: string;
    updateTime?: string;
    code?: string;
    title?: string;
    description?: string;
}

export interface IService{
    name: string;
    description: string;
    primaryKeyPart: string;
    secondaryKeyPart: string;
    serviceId: string;
    serviceName: string;
    serviceDescription: string;
}

export class IClientServiceMap {
    clientServiceId: string;
    clientId: string;
    serviceId: string;
    serviceAlias: string;
    registered: boolean;
    createUser: string;
    updateUser: string;   
    createDate: string;
    updateDate: string;
}

export class IIssue {
    issueId: string;
    issueTitle: string;
    issueState: string;
    issueStatus: string;
    createDate: string;
    updateDate: string;
    createUser: string;
    updateUser: string;
}

export class IIssueDetail {
    issueId: string;
    createtime: string;
    issueState: string;   
    updateUser: string;
    updateDate: string;
    issueComment: string;
}

export class IIssueClientServiceMap {
    issueMapId: string;
    issueId: string;
    clientId: string;
	serviceId: string;
    clientServiceId: string;
    issueState: string;
    resolutionDate: string;
    createDate: string;
    updateDate: string;
    createUser: string;
    updateUser: string;
}

export interface IStatusType{
    statusName: string;
    statusPrecedence: number;
    statusMessage: string;
    showServiceList: boolean;
    statusColorCode: string;
    primaryKeyPart: string;
    secondaryKeyPart: string;
}